import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { useHeader } from '@/data/Content/Header';
import { Skeleton } from '@mui/material';

const id = 'header';

export const ShortHeaderLogo = () => {
	const { contentItems } = useHeader(id);

	return (
		<>
			{contentItems.map((properties) => (
				<ContentRecommendation
					key={properties.emsName}
					id={`${id}-${properties.emsName}`}
					properties={properties}
					withoutFrame
					loadingElement={
						<Skeleton
							variant="rectangular"
							sx={{
								width: { xs: '126px !important', md: '165px !important' },
								height: '28px !important',
							}}
						/>
					}
				/>
			))}
		</>
	);
};
